import {Bank} from '../bank';

export function toString(this: Bank) {
    return `Deal: ${this.id}`;
}
